import LsdApiModel  from './global/LsdApiModel';
import { computed } from 'mobx';

export default class ProjectSubCategoryModel extends LsdApiModel {
	static get path(): string {
		return '/project_sub_categories/{?id}';
	}

	@computed
	get activated() {
		return this.get('activated');
	}

	@computed
	get code() {
		return this.get('code');
	}

	@computed
	get projectCategoryId() {
		return this.get('projectCategory.id');
	}

	@computed
	get projectCategoryIri() {
		return this.get('projectCategory.@id');
	}

	@computed
	get title() {
		return this.get('title');
	}
}
